<template>
    <div class="popup-container">
        <div class="breadcrumb">
            콘텐츠 관리 &gt; 팝업/알림 배너 관리
        </div>
        <div class="filter-row">
            <select v-model="status" class="select-status">
                <option>전체</option>
                <!-- 필요하다면 다른 옵션도 추가하세요 -->
            </select>
            <input v-model="searchTerm" class="search-box" placeholder="검색어 입력" />
            <button class="btn search" @click="fetchPopups">검색</button>
        </div>
        <div class="button-row">
            <button class="btn delete" @click="deleteSelected">삭제</button>
            <button class="btn edit" @click="editSelected">수정</button>
            <button class="btn register" @click="registerPopup">등록</button>
        </div>
        <table class="popup-table notice-table">
            <thead>
            <tr>
                <th><input type="checkbox" :checked="allSelected" @change="toggleAll" /></th>
                <th>제목</th>
                <th>작성일</th>
                <th>작성자</th>
                <th>노출 대상</th>
                <th>상태</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, idx) in popupData" :key="idx">
                <td><input type="checkbox" v-model="selectedPopups" :value="row.id" /></td>
                <td>{{ row.title }}</td>
                <td>{{ row.date }}</td>
                <td>{{ row.author }}</td>
                <td>{{ row.target }}</td>
                <td>{{ row.status }}</td>
            </tr>
            </tbody>
        </table>
        <div class="pagination">&lt; 1 &gt;</div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'Popup',
    data() {
        return {
            status: '',
            searchTerm: '',
            popupData: [],              // 팝업 데이터 배열
            selectedPopups: [],         // 체크된 팝업 id 리스트
            allSelected: false
        };
    },
    methods: {
        async fetchPopups() {
            try {
                const res = await axios.get(`/api/content/PopupList`, {
                    // 검색 조건 필요 시 params로 넘기고, 예: params: { status: this.status, searchTerm: this.searchTerm }
                });
                this.popupData = res.data.list || res.data || [];
                this.selectedPopups = [];
                this.allSelected = false;
            } catch (err) {
                console.error('팝업 목록 불러오기 실패', err);
            }
        },
        toggleAll(event) {
            this.allSelected = event.target.checked;
            if (this.allSelected) {
                this.selectedPopups = this.popupData.map(item => item.id);
            } else {
                this.selectedPopups = [];
            }
        },
        deleteSelected() {
            if (this.selectedPopups.length === 0) {
                alert('삭제할 항목을 선택하세요.');
                return;
            }
            if (!confirm(`선택한 ${this.selectedPopups.length}개의 팝업을 삭제하시겠습니까?`)) {
                return;
            }
            const params = {
                idList: this.selectedPopups
            };
            axios.post('/api/content/PopupDelete', params)
                .then(() => {
                    alert('삭제되었습니다.');
                    this.fetchPopups();
                })
                .catch(err => {
                    console.error('삭제 실패', err);
                    alert('삭제 중 오류가 발생했습니다.');
                });
        },
        editSelected() {
            if (this.selectedPopups.length === 0) {
                alert('수정할 항목을 선택하세요.');
                return;
            }
            if (this.selectedPopups.length > 1) {
                alert('하나의 팝업만 수정할 수 있습니다.');
                return;
            }
            const selectedId = this.selectedPopups[0];
            this.$router.push({ name: 'PopupEdit', params: { id: selectedId } });
        },
        registerPopup() {
            this.$router.push({ name: 'PopupRegister' });
        }
    },
    mounted() {
        this.fetchPopups();
    }
};
</script>

